import { render, staticRenderFns } from "./Fullvideo.vue?vue&type=template&id=f9c57c98&scoped=true&"
import script from "./Fullvideo.vue?vue&type=script&lang=js&"
export * from "./Fullvideo.vue?vue&type=script&lang=js&"
import style0 from "./Fullvideo.vue?vue&type=style&index=0&id=f9c57c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c57c98",
  null
  
)

export default component.exports